module.exports = __webpack_public_path__ + "151714df0fea994ff25db833a9e9fea1.svg";